import api from '../library/axios';
import config from '../config';

export default {
  create({ workspace_id, data }) {
    return api({
      method: 'POST',
      baseURL: config.api.vCallUrl,
      url: `/api/meet/${workspace_id}`,
      data,
    });
  },
  extra({ workspace_id, id, data }) {
    return api({
      method: 'POST',
      baseURL: config.api.vCallUrl,
      url: `/api/meet/${workspace_id}/${id}/extra`,
      data,
    });
  },
  detail({ workspace_id, id }) {
    return api({
      method: 'GET',
      baseURL: config.api.vCallUrl,
      url: `/api/meet/${workspace_id}/${id}`,
    });
  },
  participants({ workspace_id, id }) {
    return api({
      method: 'GET',
      baseURL: config.api.vCallUrl,
      url: `/api/meet/${workspace_id}/${id}/participants`,
    });
  },
  cancel_meeting({ workspace_id, id }) {
    return api({
      method: 'PATCH',
      baseURL: config.api.vCallUrl,
      url: `/api/meet/${workspace_id}/${id}/cancel`,
    });
  },
  join({ workspace_id, id, data }) {
    return api({
      method: 'POST',
      baseURL: config.api.vCallUrl,
      url: `/api/meet/${workspace_id}/${id}/join`,
      data,
    });
  },
  end(workspace_id, id) {
    return api({
      method: 'GET',
      baseURL: config.api.vCallUrl,
      url: `/api/meet/${workspace_id}/${id}/end`,
    });
  },
  leave(meeting_id, participant_id) {
    return api({
      method: 'PATCH',
      baseURL: config.api.vCallUrl,
      url: `/api/participant/${meeting_id}/${participant_id}`,
    });
  },
};
